import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  answer1: {
    id: `ea_plans_answer1`,
    defaultMessage: `Your Memrise membership applies to your username rather than specific languages. This means that you'll be able to access all Scenarios across all languages available on the app and website.`,
  },

  answer2: {
    id: `ea_plans_answer2`,
    defaultMessage: `On Memrise, you can access and learn as many languages as you want at the same time!`,
  },

  answer3: {
    id: `ea_plans_answer3`,
    defaultMessage: `If you select the Lifetime plan, the amount will be charged as a one-off upfront payment without any renewals and you'll have Pro status forever.`,
  },

  answer4: {
    id: `ea_plans_answer4`,
    defaultMessage: `Yes! You can access your Memrise profile and use your Pro membership on more than one device: simply log in with the same details on your iOS and Android mobile apps, or on your computer.`,
  },

  answer5: {
    id: `ea_plans_answer5`,
    defaultMessage: `Yes, you can cancel your auto-renewal any time after you have been charged for your subscription. The paid features will remain active until the end of your membership period. If you purchase a Lifetime plan, you won’t need to cancel your auto-renewal as it’s a one-off purchase.`,
  },

  help: {
    id: `ea_plans_help`,
    defaultMessage: `Help`,
  },

  popularQuestions: {
    id: `ea_plans_popularquestions`,
    defaultMessage: `Popular questions`,
  },

  question1: {
    id: `ea_plans_question1`,
    defaultMessage: `Does my membership apply to all languages?`,
  },

  question2: {
    id: `ea_plans_question2`,
    defaultMessage: `Can I learn more than one language on my account?`,
  },

  question3: {
    id: `ea_plans_question3`,
    defaultMessage: `How does the Lifetime plan work?`,
  },

  question4: {
    id: `ea_plans_question4`,
    defaultMessage: `Can I use my account on multiple devices?`,
  },

  question5: {
    id: `ea_plans_question5`,
    defaultMessage: `Can I cancel my Pro membership at any time?`,
  },
});
